import { useDisciplineStore } from '@entities/customer'
import { useToast } from '@shared/lib/toast'
import { useCsRoutes } from '@shared/api'

interface DisciplineInfoUpdateApiPayload {
  disciplineId: number
  data: {
    discipline: {
      additional_practice: boolean
    }
  }
}

interface DisciplineInfoUpdateApiOptions {
  onStart?: () => void
  onSuccess?: (data: any) => void
  onError?: () => void
  onFinish?: () => void
}

export const useDisciplineInfoUpdateApi = async (payload: DisciplineInfoUpdateApiPayload, options?: DisciplineInfoUpdateApiOptions): Promise<void> => {
  const { $axios } = useNuxtApp()

  const disciplineStore = useDisciplineStore()
  const toast = useToast()

  const id = payload.disciplineId || disciplineStore.activeDiscipline?.id || null

  const setError = (msg: string): void => {
    toast.error(`Unexpected error. ${msg} Please refresh the page and try again.`)
    options?.onError?.()
  }

  options?.onStart?.()

  if (!id) {
    setError('Invalid discipline ID.')
    return
  }

  const url = useCsRoutes('discipline.update', { '[discipline_id]': id })

  if (!url) {
    setError('Invalid request URL.')
    return
  }

  try {
    const { data } = await $axios.patch(url, payload.data)

    options?.onSuccess?.(data.data)
  } catch (err: any) {
    setError(err.response?.data?.message || err?.message)
  } finally {
    options?.onFinish?.()
  }
}
